import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApiService } from './shared/service/api.service';
import { LocalStorageService } from './shared/service/localstorage.service';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GOOGLE_API_KEY } from './shared/constants/constants';
import { AuthGuard } from './auth.guard';
import { UserService } from './shared/service/user.service';
import { BreadcrumbModule } from './shared/components/breadcrumb/breadcrumb.module';
import { CardURLConvertor } from './shared/pipes/CardURLConvertor';
import { FlashmessageModule } from './shared/components/flashmessage/flashmessage.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HalfwidthadModule } from './shared/components/halfwidthad/halfwidthad.module';
import { FullwidthadModule } from './shared/components/fullwidthad/fullwidthad.module';
import { StillimageadModule } from './shared/components/stillimagead/stillimagead.module';
import { OfferModule } from './shared/components/offer/offer.module';
import { LogoSvgModule } from './shared/components/logo-svg/logo-svg.module';
import { StateRouting } from './state-routing';
import { HomelandingComponent } from './homelanding/homelanding.component';
import { HomebannerModule } from './shared/components/homebanner/homebanner.module';
import { BrandLogoModule } from './shared/components/brand-logo/brand-logo.module';
import { AboutUsComponent } from './shared/components/about-us/about-us.component';
import { AboutUsModule } from './shared/components/about-us/about-us.module';
import { EventModule } from './shared/components/event/event.module';
import { TestimonialModule } from './shared/components/testimonial/testimonial.module';
import { FaqModule } from './shared/components/faq/faq.module';
import { PartnerPageModule } from './partner-page/partner-page.module';
import { HeaderModule } from './shared/components/header/header.module';
import { FooterModule } from './shared/components/footer/footer.module';
import { PageBannerComponent } from './shared/components/page-banner/page-banner.component';
import { PageBannerModule } from './shared/components/page-banner/page-banner.module';
import { MainFaqModule } from './shared/components/main-faq/main-faq.module';
import { FaqBannerModule } from './shared/components/faq-banner/faq-banner.module';


@NgModule({
  declarations: [
    AppComponent,

    // CardURLConvertor,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    StateRouting,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BreadcrumbModule,
    FlashmessageModule,
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    HalfwidthadModule,
    FullwidthadModule,
    StillimageadModule,
    OfferModule,
    LogoSvgModule,
    HomebannerModule,
    BrandLogoModule,
    AboutUsModule,
    EventModule,
    TestimonialModule,
    FaqModule,
    PartnerPageModule,
    HeaderModule,
    FooterModule,
    PageBannerModule,
    MainFaqModule,
    FaqBannerModule
  ],
  providers: [
    ApiService,
    LocalStorageService,
    UserService,
    AuthGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
